// Recovered compiled webpack factory 48866. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, { McpArt: () => l });
  var n = r(95155),
    a = r(12115),
    s = r(65025);
  let i = [
    {
      at: 0,
      prompt: "Tilt the iPhone on a nice angle",
      tool: "update_mockup",
      arg: "tilt_y −24\xb0",
    },
    {
      at: 2.75,
      prompt: "Zoom in and focus on the bottom area",
      tool: "set_focus_areas",
      arg: "0,0.62 → 1,1",
    },
    { at: 5.75, prompt: "Now focus on the top area", tool: "set_focus_areas", arg: "0,0 → 1,0.38" },
    {
      at: 8.25,
      prompt: "Reset iPhone pose",
      tool: "update_mockup",
      arg: "tilt_y 0\xb0 \xb7 zoom 1",
    },
  ];
  function l() {
    let e = (0, a.useRef)(null),
      t = (0, a.useRef)([]),
      r = (0, a.useRef)([]),
      l = (0, a.useRef)([]),
      c = (0, a.useRef)([]);
    return (
      (0, a.useEffect)(() => {
        let n = e.current;
        if (!n || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        let a = !1,
          s = 0,
          o = "",
          d = () => {
            let e = (function (e) {
                let t = 0,
                  r = 0;
                for (let n of i) (e >= n.at && (t += 1), e >= n.at + 0.66 + 0.22 && (r += 1));
                let n = i[t - 1];
                return {
                  revealed: t,
                  chars: n ? Math.round(Math.min(1, (e - n.at) / 0.66) * n.prompt.length) : 0,
                  answered: r,
                };
              })(n.currentTime),
              a = `${e.revealed}:${e.chars}:${e.answered}`;
            (a !== o &&
              ((o = a),
              i.forEach((n, a) => {
                let s = a === e.revealed - 1,
                  i = t.current[a];
                i && (i.style.opacity = a < e.revealed ? "1" : "0");
                let o = r.current[a];
                o &&
                  (o.textContent = s ? n.prompt.slice(0, e.chars) : a < e.revealed ? n.prompt : "");
                let d = l.current[a];
                d && (d.style.opacity = a < e.answered ? "1" : "0");
                let u = c.current[a];
                u && (u.style.visibility = s ? "visible" : "hidden");
              })),
              (s = requestAnimationFrame(d)));
          },
          u = () => {
            let e = a && !document.hidden;
            (e && n.paused ? n.play().catch(() => {}) : e || n.paused || n.pause(),
              e && !s
                ? (s = requestAnimationFrame(d))
                : !e && s && (cancelAnimationFrame(s), (s = 0)));
          },
          m = new IntersectionObserver(
            (e) => {
              for (let t of e)
                (t.isIntersecting && "none" === n.preload && ((n.preload = "auto"), n.load()),
                  (a = t.isIntersecting));
              u();
            },
            { threshold: 0.2, rootMargin: "300px 0px" },
          );
        return (
          m.observe(n),
          document.addEventListener("visibilitychange", u),
          () => {
            (m.disconnect(),
              document.removeEventListener("visibilitychange", u),
              s && cancelAnimationFrame(s));
          }
        );
      }, []),
      (0, n.jsxs)("div", {
        "data-um-art": "mcp",
        className: "relative h-full w-full overflow-hidden bg-black/[0.03] dark:bg-white/[0.03]",
        children: [
          (0, n.jsxs)("video", {
            ref: e,
            className: "absolute inset-0 h-full w-full object-contain object-right",
            poster: "/mcp-iphone.webp",
            "aria-label":
              "An iPhone mockup tilting, pushing into the bottom of its screen, then the top, then returning to its resting pose",
            preload: "none",
            muted: !0,
            loop: !0,
            playsInline: !0,
            disablePictureInPicture: !0,
            disableRemotePlayback: !0,
            children: [
              (0, n.jsx)("source", { src: "/mcp-iphone.mp4", type: 'video/mp4; codecs="hvc1"' }),
              (0, n.jsx)("source", { src: "/mcp-iphone.webm", type: "video/webm" }),
            ],
          }),
          (0, n.jsx)("div", {
            className: "absolute inset-y-6 left-6 flex w-[44%] max-w-[260px] flex-col",
            children: (0, n.jsxs)("div", {
              className:
                "min-h-0 flex-1 overflow-hidden squircle-md border border-white/70 bg-white/55 px-3 py-2.5 shadow-[inset_0_1px_0_rgba(255,255,255,0.65),0_10px_30px_-16px_rgba(0,0,0,0.4)] backdrop-blur-xl dark:border-white/[0.14] dark:bg-white/[0.07] dark:shadow-[inset_0_1px_0_rgba(255,255,255,0.10),0_10px_30px_-16px_rgba(0,0,0,0.7)]",
              children: [
                (0, n.jsxs)("div", {
                  className: `${s.iP} flex items-center gap-1.5 border-b border-black/[0.08] pb-2 text-[9px] uppercase tracking-[0.14em] text-[#71717a] dark:border-white/[0.10] dark:text-[#a1a1aa]`,
                  children: [
                    (0, n.jsx)(o, {}),
                    (0, n.jsx)("span", { children: "claude" }),
                    (0, n.jsx)("span", {
                      className:
                        "ml-auto normal-case tracking-[0.06em] text-[#c4c4c8] dark:text-[#52525b]",
                      children: "Mockup Studio",
                    }),
                  ],
                }),
                (0, n.jsx)("ul", {
                  className: "mt-2 space-y-[7px]",
                  children: i.map((e, a) =>
                    (0, n.jsxs)(
                      "li",
                      {
                        ref: (e) => {
                          t.current[a] = e;
                        },
                        className: "transition-opacity duration-200",
                        children: [
                          (0, n.jsxs)("div", {
                            className: "relative",
                            children: [
                              (0, n.jsxs)("div", {
                                "aria-hidden": !0,
                                className: `${s.iP} invisible text-[10px] leading-[1.35] break-words`,
                                children: [
                                  (0, n.jsx)("span", { className: "mr-1.5", children: "›" }),
                                  e.prompt,
                                  (0, n.jsx)("span", {
                                    className: "ml-[3px] inline-block h-[9px] w-[4px]",
                                  }),
                                ],
                              }),
                              (0, n.jsxs)("div", {
                                className: `${s.iP} absolute inset-0 text-[10px] leading-[1.35] break-words text-[#18181b] dark:text-[#e4e4e7]`,
                                children: [
                                  (0, n.jsx)("span", {
                                    className: "mr-1.5 text-[#FD6421]",
                                    children: "›",
                                  }),
                                  (0, n.jsx)("span", {
                                    ref: (e) => {
                                      r.current[a] = e;
                                    },
                                    children: e.prompt,
                                  }),
                                  (0, n.jsx)("span", {
                                    ref: (e) => {
                                      c.current[a] = e;
                                    },
                                    className: `um-mcp-caret ml-[3px] inline-block h-[9px] w-[4px] translate-y-[1px] bg-[#FD6421] ${a === i.length - 1 ? "" : "invisible"}`,
                                  }),
                                ],
                              }),
                            ],
                          }),
                          (0, n.jsxs)("span", {
                            ref: (e) => {
                              l.current[a] = e;
                            },
                            className: `${s.iP} mt-[3px] flex items-center gap-1.5 pl-[13px] text-[9px] leading-none transition-opacity duration-200`,
                            children: [
                              (0, n.jsx)("span", {
                                className: "h-1 w-1 shrink-0 rounded-full bg-[#FD6421]",
                              }),
                              (0, n.jsx)("span", {
                                className: "text-[#09090b] dark:text-[#fafafa]",
                                children: e.tool,
                              }),
                              (0, n.jsx)("span", {
                                className: "truncate text-[#a1a1aa] dark:text-[#71717a]",
                                children: e.arg,
                              }),
                            ],
                          }),
                        ],
                      },
                      e.prompt,
                    ),
                  ),
                }),
              ],
            }),
          }),
        ],
      })
    );
  }
  function o() {
    return (0, n.jsx)("svg", {
      "aria-hidden": !0,
      viewBox: "0 0 12 12",
      className: "h-[9px] w-[9px] shrink-0 text-[#FD6421]",
      fill: "currentColor",
      children: (0, n.jsx)("path", {
        d: "M6 0C6.35 3.1 8.9 5.65 12 6c-3.1.35-5.65 2.9-6 6-.35-3.1-2.9-5.65-6-6 3.1-.35 5.65-2.9 6-6Z",
      }),
    });
  }
}
